import { ReactNode } from "react";
import { Title } from "react-head";
import { cx } from "utils";


interface IPageProps {
  title?: ReactNode,
  subtitle?: ReactNode,
  browserTitle?: string,
  stickyTitle?: boolean,
  children?: ReactNode
}

export default function Page(
  {
    title,
    subtitle,
    browserTitle,
    stickyTitle,
    children
  }: IPageProps
) {
  const titleInBrowser = browserTitle ?? (typeof title === "string" ? title : undefined);

  return (
    <div className="px-2 md:px-8 dark:md:px-6 relative">
      <Title>ScraperAPI{ titleInBrowser && (" | " + titleInBrowser) }</Title>
      <div className={ cx("py-6", stickyTitle && "sticky top-0 bg-white z-10") }>
        <div className="text-2xl font-semibold">
          { title }
        </div>
        { subtitle && (
          <div className="text-md py-2 font-light dark:font-normal">
            { subtitle }
          </div>
        )}
      </div>

      { children }
    </div>
  );
};
